<template>
  <v-row align="stretch" justify="center">
    <v-col cols="12" sm="12" md="8" lg="6" xl="5">
      <Login v-if="!isAuthenticated" :dense="true"></Login>
      <v-card v-if="isAuthenticated" tile>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Checkout</v-toolbar-title>
        </v-toolbar>
        <v-card-title>
          Buyer
          <v-spacer />
          <MiniProfile :user="user" />
        </v-card-title>
        <v-divider />
        <v-card-title>
          Plan
          <v-spacer></v-spacer>
          {{plan.name}}
        </v-card-title>
        <v-list subheader dense>
          <v-subheader>
            Details
            <v-divider />
          </v-subheader>
          <v-list-item>
            <v-icon>chevron_right</v-icon>
            <v-list-item-content>Original Price / month:</v-list-item-content>
            <v-list-item-content class="font-weight-black">${{ plan.price }}</v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-icon>chevron_right</v-icon>
            <v-list-item-content>Discount:</v-list-item-content>
            <v-list-item-content class="font-weight-black">-{{ plan.discount }}%</v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-icon>chevron_right</v-icon>

            <v-list-item-content>Price After Discount / month:</v-list-item-content>
            <v-list-item-content class="font-weight-black">${{ plan.priceAfterDiscount }}</v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-icon>chevron_right</v-icon>

            <v-list-item-content>Recurring Month:</v-list-item-content>
            <v-list-item-content
              class="font-weight-black"
            >{{ plan.month>0 ? plan.month : 'unlimted' }} months</v-list-item-content>
          </v-list-item>
          <v-divider />
          <v-list-item class="font-weight-black" color="primary">
            <v-icon>functions</v-icon>
            <v-list-item-content>Total Price / {{plan.month>0 ? plan.month : 'unlimted'}} months:</v-list-item-content>
            <v-list-item-content>${{ plan.priceAfterDiscount * plan.month }}</v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
      <PayPal
        v-if="plan.paypalId"
        :plan-id="plan.paypalId"
        @approve="onApprove"
        @cancel="onCancel"
        @error="onError"
      ></PayPal>
      <Plan :item="plan" :checkout="true" @cancelCheckout="onCancel"></Plan>
    </v-col>
  </v-row>
</template>

<script>
import Login from "@/components/auth/Login";
import MiniProfile from "@/components/users/miniProfile";
import Plan from "@/components/products/Card";
import PayPal from "@/components/payments/PayPal";
import { mapGetters } from "vuex";
import { SALE, USER } from "@/store/actions.type";

export default {
  name: "CheckOut",
  components: {
    Plan,
    Login,
    PayPal,
    MiniProfile
  },
  props: {
    plan: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      user: null,
      sale: {
        planId: null,
        planName: null,
        status: null,
        orderID: null,
        subscriptionID: null,
        userId: null
      }
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated", "currentUser"])
  },

  mounted() {
    this.getUser();
  },
  methods: {
    onFreePlan() {
      if (!this.isAuthenticated) {
        return null;
      }
      this.user.planId = this.plan.id;
      this.user.subscriptionID = null;
      this.user.saleId = null;
      this.user.badges[0] = this.plan.code;
      this.updateUser(this.user);
      // save Sale
      this.updateSale();
      this.sale.id = null;
      this.sale.status = "success";
      this.sale.orderID = null;
      this.sale.subscriptionID = null;
      this.setSale(this.sale);
    },
    updateSale() {
      if (!this.isAuthenticated) {
        return null;
      }
      (this.sale.planId = this.plan.id),
        (this.sale.planName = this.plan.name),
        (this.sale.userId = this.user.id);
    },
    onApprove(v) {
      if (!this.isAuthenticated) {
        return null;
      }
      this.user.planId = this.plan.id;
      this.user.subscriptionID = v.subscriptionID;
      this.user.saleId = v.subscriptionID;
      this.user.badges[0] = this.plan.code;
      this.updateUser(this.user);

      // save Sale
      this.updateSale();
      this.sale.id = v.subscriptionID;
      this.sale.status = "success";
      this.sale.orderID = v.orderID;
      this.sale.subscriptionID = v.subscriptionID;
      this.setSale(this.sale);
    },
    onCancel(v) {
      this.$emit("cancel", true);

      if (!this.isAuthenticated) {
        return null;
      }
      this.updateSale();
      this.sale.status = "cancel";
      this.orderID = v.orderID;
      this.setSale(this.sale);
    },
    onError(v) {
      if (!this.isAuthenticated) {
        return null;
      }
      this.updateSale();
      this.sale.status = "error";
      this.orderID = v.orderID;
      this.setSale(this.sale);
      this.$emit("cancel", true);
    },
    getUser() {
      if (this.currentUser.ext) {
        this.user = this.currentUser.ext;
      } else {
        this.$store.dispatch(USER.GET, this.currentUser.uid).then(data => {
          this.user = data;
        });
      }
    },
    updateUser(schema) {
      this.$store.dispatch(USER.EDIT, schema);
    },
    setSale(schema) {
      if (this.isAuthenticated) {
        this.$store.dispatch(SALE.CREATE, schema);
      }
    }
  }
};
</script>

<style>
</style>